const WINDOW_SIZE = 5;

export function computePageRange(currentPage: number, totalPages: number): number[] {
  if (totalPages <= 0) return [];

  const clamped = Math.max(1, Math.min(currentPage, totalPages));

  if (totalPages <= WINDOW_SIZE) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const half = Math.floor(WINDOW_SIZE / 2);
  let start = clamped - half;
  let end = clamped + half;

  if (start < 1) {
    start = 1;
    end = WINDOW_SIZE;
  } else if (end > totalPages) {
    end = totalPages;
    start = totalPages - WINDOW_SIZE + 1;
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}
